export const checkIfProductIsClicked = (idProductInMenu, idProductClickedOn) => {
    return idProductInMenu === idProductClickedOn
  }
  